var map = {
	"./ABISYSCS4.jpg": "9e36",
	"./BPSYS.jpg": "3e4d",
	"./BPSYSCS4.jpg": "7401",
	"./ECGSYSCS4.jpg": "2d29",
	"./MTABSYSW.jpg": "5179",
	"./SPIROSYSCS4.jpg": "b454",
	"./SPO2SYS.jpg": "803a",
	"./TBISYSCS4.jpg": "96b0",
	"./TBPSYSCS4.jpg": "6b75",
	"./THERMOSYSCS4.jpg": "6837",
	"./VITALSSYSCS4.jpg": "e827"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69fc";